{
	"columns":[
        {
			"header_id": "providerId",
			"header_label": "Provider ID",
			"jsonpath":  "providerId" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		},
        {
			"header_id": "tasMasterPayrollScheduleId",
			"header_label": "TimeSheet ID",
			"jsonpath":  "tasMasterPayrollScheduleId" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		},
        {
			"header_id": "fromDate",
			"header_label": "From Date",
			"jsonpath":  "fromDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "toDate",
			"header_label": "To Date",
			"jsonpath":  "toDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "consumerName",
			"header_label": "Consumer Name",
			"jsonpath":  "consumerName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "participantPPLId",
			"header_label": "Consumer PPL ID",
			"jsonpath":  "participantPPLId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "providerTimesheet.json",
	"pageName": "providertimesheetlist1",
	"orderByColumn": ["tasMasterPayrollScheduleId"],
	"orderBy": ["desc"]
}